import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Custom link component that preserves redirect URL when navigating between auth pages
 */
const AuthLink: React.FC<AuthLinkProps> = ({ to, children, className }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Just navigate - the redirect URL should already be saved from when user first hit checkout
    // We don't need to modify it when switching between auth pages
    navigate(to);
  };

  return (
    <a 
      href={to} 
      onClick={handleClick}
      className={className}
    >
      {children}
    </a>
  );
};

export default AuthLink;